import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggerService } from 'projects/shared/lib/services/infrastructure/logger/logger.service';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { CartPreviewComponent } from '../../cart/preview/cart-preview.component';

@Component({
  selector: 'app-sidebar-cart',
  imports: [
    CommonModule,
    CartPreviewComponent,
  ],
  templateUrl: './sidebar-cart.component.html',
  styleUrls: ['./sidebar-cart.component.scss']
})
export class SidebarCartComponent {
  protected logger: LoggerService;

  public constructor() {
    this.logger = ServiceLocator.injector.get(LoggerService);
  }
}
